import ReportModal from 'components/Widgets/ReportModal'
import React, { Fragment, useState } from 'react'
import { ReportDiv } from './MainInfo/MainInfo.style'
import Report from '../../Icons/Report'

const ReportSection = props => {
  const [reportModal, setReportModal] = useState(false)

  return (
    <Fragment>
      <ReportDiv
        className={`report ${props.className}`}
        onClick={() => {
          setReportModal(true)
        }}
      >
        <Report height="25px" width="25px" />
        <p>შეგვატყობინე არასწორი ინფორმაცია</p>
      </ReportDiv>
      <ReportModal open={reportModal} onClose={() => setReportModal(false)} />
    </Fragment>
  )
}

export default ReportSection
